import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <p className="footer-text">
            © {new Date().getFullYear()} Bob Map - Tous droits réservés
          </p>
        </div>

        <div className="footer-links">
          <Link to="/privacy-policy" className="footer-link">
            Politique de confidentialité
          </Link>
          <span className="footer-separator">•</span>
          <Link to="/terms" className="footer-link">
            Conditions d'utilisation
          </Link>
          <span className="footer-separator">•</span>
          <Link to="/legal" className="footer-link">
            Mentions légales
          </Link>
          <span className="footer-separator">•</span>
          <Link to="/child-safety" className="footer-link">
            Protection des mineurs
          </Link>
        </div>

        <div className="footer-section">
          <p className="footer-info">
            Hugo Bachellier - SIREN 924766702
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
